module.exports = __webpack_public_path__ + "img/partner_60.0c537bcf.png";